import { CWTSchema } from '../../../types/custom-worksheet-v2';
import { SchemaState } from './store';

/**
 * Select CWT schema
 *
 * @returns CWTSchema
 */
export function selectSchema(state: SchemaState): CWTSchema {
    if (!state.schema?.value) {
        return {
            properties: {},
            version: '1.0.0',
            reviewConditions: [],
        };
    }

    return state.schema.value;
}

/**
 * Select property that is currently being renamed
 *
 * @returns Id for property that's currently being renamed
 */
export function selectRenamingProperty(state: SchemaState): string | undefined {
    return state.schema.renamingPropertyId;
}

/**
 * Select property with description currently being edited
 *
 * @returns Id for property with description currently being edited
 */
export function selectUpdatingDescriptionProperty(state: SchemaState): string | undefined {
    return state.schema.updatingDescriptionPropertyId;
}

/**
 * Select field with reference currently being edited
 *
 * @returns Id for field with reference currently being edited
 */
export function selectUpdatingReferenceField(state: SchemaState): string | undefined {
    return state.schema.updatingReferenceFieldId;
}

/**
 * Select field with type currently being edited
 *
 * @returns Id for field with type currently being edited
 */
export function selectUpdatingTypeField(state: SchemaState): string | undefined {
    return state.schema.updatingTypeFieldId;
}

/**
 * Select current list of references
 *
 * @returns References list
 */
export function selectReferencesList(state: SchemaState): { [key: string]: boolean } {
    return state.schema.referenceMap;
}

/**
 * Select property that is currently being focused
 *
 * @returns Id for property that's currently being focused
 */
export function selectCurrentFocusProperty(state: SchemaState): string | undefined {
    return state.schema.currentFocusPropertyId;
}
